import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { EvidenceList } from './evidence-list';
import { EvidenceDetails } from './evidence-details/evidence-details';

export const EvidenceOutlet: React.FunctionComponent = () => {
    return (
        <Routes>
            <Route path="" element={<EvidenceList />} />
            <Route path=":evidenceId" element={<EvidenceDetails />} />
        </Routes>
    );
};

